module.exports = __webpack_public_path__ + "static/media/download.5f040f04.svg";